import { Question } from 'app/question';

export type SurveyId = string;

export class Survey {
  constructor(
    private id: SurveyId,
    public name: string,
    public type: string = null,
    public createdAt: Date = new Date(),
    public randomizedQuestions: boolean = true,
    public reanswerEnabled: boolean = false,
    public questions: Question[] = [],
    public description?: string,
    public questionsPerPage?: number,
    public isDeletable?: boolean,
    public isEditable?: boolean,
    public sessionsTotal?: number
  ) { }

  public getId(): SurveyId {
    return this.id;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/survey/survey.model.ts